import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { createDialog } from '@patsnap/tahiti-core';
import type {
    CommandContribution,
    CommandRegistry,
} from '@patsnap/tahiti-core';
import type { TrialEndDialogResult } from '../../components/TrialEndDialog.vue';

// Re-export types for external use
export type { TrialEndDialogResult };

/**
 * TrialEnd 对话框服务工厂
 */
const trialEndDialogServiceFactory = createDialog(() => import('../../components/TrialEndDialog.vue'));

/**
 * TrialEnd 对话框命令处理器
 */
@injectable()
export class TrialEndDialogCommandHandler implements CommandContribution {
    private _dialogService = trialEndDialogServiceFactory();

    /**
     * 处理打开 TrialEnd 对话框命令
     */
    private async _handleOpenTrialEndDialog(): Promise<TrialEndDialogResult> {
        return new Promise((resolve) => {
            const dialog = this._dialogService;

            dialog.onSubmit(async (result, next) => {
                resolve(result);
                next();
            });

            dialog.onCancel(() => {
                resolve({ action: 'continue' });
            });

            dialog.open({});
        });
    }

    /**
     * 注册命令
     */
    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: 'trial-end:open-dialog',
        }, {
            execute: async () => {
                return this._handleOpenTrialEndDialog();
            },
        });
    }
}

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开试用结束对话框
         */
        executeCommand(commandId: 'trial-end:open-dialog'): Promise<TrialEndDialogResult>;
    }
}
